import React, { useState, useEffect } from "react";
import SpinnerTimeLoader from "../shared/timeLoading";
import BillPaymentAccounts from "./bill-payment-accounts";
import BillPaymentService from "../../services/bill-payment.service";
import Payments from "../../services/payments.service";

export default function BillPaymentCheckSecureLink(props) {
    const { history } = props;    
    const [loader, setLoader] = useState(true);
    const [apiResponse, setAPIResponse] = useState([]);
    
	useEffect(() => {
        BillPaymentService.decryptSecureLinkId(props.secureId || "")
        .then(response => {
            setLoader(false);
            if(response.data.length > 0) {
                setAPIResponse(response.data);
            } else {
                props.hasInvalidSecureId();
            }
            Payments.normalize();
        })
        .catch(err => {
            setLoader(false);
            props.hasInvalidSecureId()
        });
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	return (
        loader ? <SpinnerTimeLoader /> :
        <>
            <BillPaymentAccounts props={props} history={history} apiResponse={apiResponse}/>
        </>
	)
}